import { TextInputM } from '@shared/ui/index';
import type { TextInputMPT } from '@shared/ui/inputs/TextInputM/ui';

type PT = TextInputMPT;
export const NumberTextInputM = (props: PT) => {
  return (
    <TextInputM
      type={'number'}
      placeholder={'0'}
      inputMode={'numeric'}
      // onPaste={() => false}
      onInput={(e) => {
        const number = Number(e.currentTarget.value);
        if (number !== 0) {
          e.currentTarget.value = String(Math.abs(Number(e.currentTarget.value)));
        }
      }}
      onKeyDown={(e) =>
        (e.key === 'e' || e.key === '-' || e.key === 'Enter' || e.key === '.') && e.preventDefault()
      }
      {...props}
    />
  );
};
